import styled, { css } from 'styled-components';
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
export const Buttoned = styled(Flex).attrs(props => Object.assign({}, props))`
  ${({
  shouldHover
}) => shouldHover && css`
      &:hover {
        border-color: ${getBackgroundColor('primary')};
      }
    `}
`;